import React from 'react';

import { NavbarVariantProps } from '@edx/components/navbar';

type State = {
  navBar: NavbarVariantProps;
};

type ThemeContextProviderProps = {
  value?: State;
  children: React.ReactNode;
};

const ThemeStateContext = React.createContext<
  [State | undefined, React.Dispatch<React.SetStateAction<State>>] | undefined
>(undefined);

export const ThemeContextProvider: React.FC<ThemeContextProviderProps> = ({ value: initialValue, children }) => {
  const [theme, setTheme] = React.useState(initialValue);

  React.useEffect(() => {
    setTheme(initialValue);
  }, [initialValue, setTheme]);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return <ThemeStateContext.Provider value={[theme, setTheme]}>{children}</ThemeStateContext.Provider>;
};

export const useThemeStateContext = (): [State | undefined, React.Dispatch<React.SetStateAction<State>>] => {
  const state = React.useContext(ThemeStateContext);
  if (typeof state === 'undefined') {
    throw new Error('useThemeStateContext must be used within a ThemeStateContextProvider');
  }
  return state;
};
